import { NgModule } from '@angular/core';
import { ToastContainerComponent } from './components/toast-container.component';
import { ToastComponent } from './components/toast.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';

// MatButtonModule, MatIconModule,
@NgModule({
  imports: [CommonModule, OverlayModule],
  declarations: [ToastContainerComponent, ToastComponent],
  exports: [ToastComponent],
})
export class ToasterModule {}
